import React from "react";
import { Fab } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function WhatsAppButton() {

  const phoneNumber = "919840271137";

  return (
    <Fab
      color="success"
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000
      }}
    >
      <WhatsAppIcon />
    </Fab>
  );
}

export default WhatsAppButton;